import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';

import {getCookie} from '../../../inc/cookies';
import config from '../../../inc/config';
import {isoToDateTime, slugify} from '../../../inc/helper';

class BlogModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      blogs: [],

      filterId: '',
      filterTitle: '',
      filterActive: '',
      filterAuthor: '',
      filterAddedStartDate: '',
      filterAddedEndDate: '',

      pageCount: 0,
      resultCount: 0,
      currentPage: 1,
      limit: 10
    };
  }

  componentDidMount() {
    this.getBlogs(this.state.currentPage);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
  }

  filteredBlogs(currentPage) {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const query = `limit=${this.state.limit}&page=${currentPage}&filterId=${this.state.filterId}&filterTitle=${this.state.filterTitle}&filterActive=${this.state.filterActive}&filterAuthor=${this.state.filterAuthor}&filterAddedStartDate=${this.state.filterAddedStartDate}&filterAddedEndDate=${this.state.filterAddedEndDate}`;

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    const startIndex = 0;
    const endIndex = startIndex + this.state.limit;

    fetch(config.restApi + `blogs/tr?${query}`, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const currentBlogs = responseData.blogs.slice(startIndex, endIndex);
          this.setState({isLoading: false, blogs: currentBlogs, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getBlogs(currentPage) {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true})

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    const startIndex = 0;
    const endIndex = startIndex + this.state.limit;

    fetch(config.restApi + `blogs/tr?limit=${this.state.limit}&page=${currentPage}`, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const currentBlogs = responseData.blogs.slice(startIndex, endIndex);
          this.setState({isLoading: false, blogs: currentBlogs, pageCount: responseData.pageCount, resultCount: responseData.resultCount, currentPage: currentPage});
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/home'));
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  handlePageClick(page) {
    this.setState({currentPage: page.selected + 1}, () => this.filteredBlogs(this.state.currentPage))
  }

  filterOnClick = (event) => {
    const query = `filterId=${this.state.filterId}&filterTitle=${this.state.filterTitle}&filterActive=${this.state.filterActive}&filterAuthor=${this.state.filterAuthor}&filterAddedStartDate=${this.state.filterAddedStartDate}&filterAddedEndDate=${this.state.filterAddedEndDate}`;
    this.filteredBlogs(1, query)
  }

  resetOnClick = (event) => {
    this.setState({
      filterId: '',
      filterTitle: '',
      filterActive: '',
      filterAuthor: '',
      filterAddedStartDate: '',
      filterAddedEndDate: '',
      currentPage: 1
    }, () => {this.setState({isLoading: true}, () => {this.filteredBlogs(this.state.currentPage);this.setState({isLoading: false});});});
  }

  handleKeyPress = (event, page) => {
    if (event.key === 'Enter') {
      const query = `filterId=${this.state.filterId}&filterTitle=${this.state.filterTitle}&filterActive=${this.state.filterActive}&filterAuthor=${this.state.filterAuthor}&filterAddedStartDate=${this.state.filterAddedStartDate}&filterAddedEndDate=${this.state.filterAddedEndDate}`;
      this.setState({isLoading: true, currentPage: 1}, () => {this.filteredBlogs(this.state.currentPage, query);this.setState({isLoading: false});});
    }
  }

  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <>
        <div className="row custom-container">
          <div className="col-xl-9">
            <div className="ibox">
              <div className="ibox-title text-darkblue d-flex justify-content-between pr-1">
                <div className="col-7 col-xl-8"><h5>Blog Listesi</h5></div>
                <Link className="btn btn-orange" titile="Blog Ekle" to="/blogAdd"><i className="fa fa-plus"></i> Blog Ekle</Link>
              </div>
              <div className="table-responsive overflow-x-auto">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="text-center text-darkblue">
                      <th>Başlık</th>
                      <th>Yazar</th>
                      <th>Görüntülenme</th>
                      <th>Eklenme Tarihi</th>
                      <th>Durum</th>
                      <th>İşlem</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {this.state.blogs.map((blogInfo) =>
                      <tr key={blogInfo.id}>
                        <td className="align-middle"><Link className="text-orange text-underline-orange" target='_blank' to={`https://${config.host}/blog/${slugify(blogInfo.title)}-${blogInfo.id}/detay`}>{blogInfo.title} <br /> Blog No: #{blogInfo.id}</Link></td>
                        <td className="align-middle">{blogInfo.author}</td>
                        <td className="align-middle"><i className="fa fa-eye mr-1 pointer" title="Görüntüleme"></i>{blogInfo.views}</td>
                        <td className="align-middle">{isoToDateTime(blogInfo.addedDate)}</td>
                        <td className="align-middle">{blogInfo.active === 1 ? 'Açık' : 'Kapalı'}</td>
                        <td className="align-middle">
                          <Link className="btn btn-orange text-center"to={"/blogEdit?id=" + blogInfo.id}>
                           <i className="fa fa-pencil text-white action-icon"></i>
                          </Link>
                        </td>
                      </tr>
                    )}
                    {this.state.blogs.length === 0 && 
                      <tr>
                        <td className="align-middle p-3" colSpan="6">Blog Bulunamadı !</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              {
                this.state.blogs.length !== 0 &&
                <ReactPaginate
                previousLabel={"Geri"}
                nextLabel={"İleri"}
                breakLabel={"..."}  
                pageCount={this.state.pageCount}
                forcePage={this.state.currentPage - 1}
                marginPagesDisplayed={1}
                onPageChange={page => this.handlePageClick(page)}
                pageRangeDisplayed={10}
                containerClassName={'pagination'}
                activeClassName={'activePage'}
                />
              }
            </div>
          </div>
          <div className="col-xl-3 order-first order-xl-last d-xl-none" id="accordion">
          <div className="ibox">
            <div className="ibox-content text-darkblue p-0">
              <h4 className="collapse-title">
                <a className="btn btn-link text-darkblue font-bold d-flex justify-content-between" data-toggle="collapse" href="#filterCollapse" title="Filtrele">Filtrele</a>
              </h4>
            </div>
            <div className="collapse" data-parent="#accordion" id="filterCollapse">
              <div className="ibox-content text-darkblue">  
                <strong>Blog No</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Blog No" type="text" value={this.state.filterId}/>
                <strong>Başlık</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterTitle: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başlık" type="text" value={this.state.filterTitle}/>
                <strong>Durum</strong>
                <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterActive: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.filterActive}>
                  <option value="">Seçiniz</option>
                  <option value="1">Açık</option>
                  <option value="0">Kapalı</option>
                </select>
                <strong>Yazar</strong>
                <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAuthor: event.target.value.replace(/[^a-zA-ZçÇğĞıİöÖşŞüÜ ]/g, '')})} onKeyDown={this.handleKeyPress} placeholder="Yazar" type="text" value={this.state.filterAuthor}/>
                <strong>Eklenme Tarihi Başlangıcı</strong>
                <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterAddedStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterAddedStartDate}/>
                <strong>Eklenme Tarihi Bitişi</strong>
                <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterAddedEndDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterAddedEndDate}/>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-orange mt-3 mr-2"><i className="fa fa-refresh" onClick={this.resetOnClick}></i> Sıfırla</button>
                  <button className="btn btn-orange mt-3" ><i className="fa fa-filter"  onClick={this.filterOnClick}></i> Filtrele</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 order-first order-xl-last d-none d-xl-block">
          <div className="ibox">
            <div className="ibox-title text-darkblue">
              <h5><i className="fa fa-filter"></i> Filtrele</h5>
            </div>
            <div className="ibox-content text-darkblue">
              <strong>Blog No</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterId: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Blog No" type="text" value={this.state.filterId}/>
              <strong>Başlık</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterTitle: event.target.value})} onKeyDown={this.handleKeyPress} placeholder="Başlık" type="text" value={this.state.filterTitle}/>
              <strong>Durum</strong>
              <select className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterActive: event.target.value})} onKeyDown={this.handleKeyPress} value={this.state.filterActive}>
                <option value="">Seçiniz</option>
                <option value="1">Açık</option>
                <option value="0">Kapalı</option>
              </select>
              <strong>Yazar</strong>
              <input className="form-control form-input mb-2 mt-1" onChange={event => this.setState({filterAuthor: event.target.value.replace(/[^a-zA-ZçÇğĞıİöÖşŞüÜ ]/g, '')})} onKeyDown={this.handleKeyPress} placeholder="Yazar" type="text" value={this.state.filterAuthor}/>
              <strong>Eklenme Tarihi Başlangıcı</strong>
              <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterAddedStartDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterAddedStartDate}/>
              <strong>Eklenme Tarihi Bitişi</strong>
              <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({filterAddedEndDate: event.target.value})} onKeyDown={this.handleKeyPress} type="date" value={this.state.filterAddedEndDate}/>
              <div className="d-flex justify-content-end">
                <button className="btn btn-orange mt-3 mr-2" onClick={this.resetOnClick}><i className="fa fa-refresh"></i> Sıfırla</button>
                <button className="btn btn-orange mt-3"  onClick={this.filterOnClick}><i className="fa fa-filter"></i> Filtrele</button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </>
  }
}

export default function Blogs() {
  return (
    <BlogModule navigate={useNavigate()} />
  )
}